<template>
  <section class="container">
    <section v-if="userInfor.inviteCount < userInfor.monthlyInviteCount">
      <img class="share-title"
           src="https://cdn.gelonghui.com/webActive/img_share_titleth.png"
           alt>
      <div class="user-infor">
        <img :src="userInfor.avatar"
             alt>
        <p class="user-name">{{userInfor.nick}}</p>
        <p class="user-tips">送您黄金会员体验资格</p>
        <input class
               type="text"
               name
               id
               v-model.trim="phoneNum"
               placeholder="请输入手机号码">
        <div class="get-code-box">
          <input type="text"
                 name
                 id
                 v-model="code"
                 placeholder="请输入验证码">
          <span>|</span>
          <button class="get-code"
                  @click="init"
                  v-if="isSendCode!==1 && isSendCode!==4">
            {{isSendCode === 2?
            '重新发送':'获取验证码'}}
          </button>
          <button disabled
                  class="re-time"
                  v-if="isSendCode === 1">已发送({{reTime}}s)</button>
        </div>
      </div>
      <img class="immediate-get"
           @click="sureBind"
           :src="!phoneNum ?'https://cdn.gelonghui.com/webActive/img_share_notclick.png':'https://cdn.gelonghui.com/webActive/img_share_click.png'"
           alt>
    </section>
    <section v-if="userInfor.inviteCount === userInfor.monthlyInviteCount">
      <img class="share-invalid"
           src="https://cdn.gelonghui.com/webActive/img_shareout_invalid.png"
           alt>
    </section>
    <img class="share-equity"
         src="https://cdn.gelonghui.com/webActive/img_share_vipexplainth.png"
         alt>
    <p>以上信息的最终解释权归格隆汇所有</p>
    <div id="captcha-box"></div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      nochecked: true,
      phoneNum: null,
      phoneCode: null,
      code: null,
      rudderInviteCode: null,
      isSendCode: 0,
      reTime: 61,
      setInTime: null,
      type: "",
      userInfor: {},
      checkCode: {
        challenge: '',
        geetestId: '',
        success: '',
      }
    };
  },
  components: {},
  created() {
    this.rudderInviteCode = this.$route.params.code;
  },
  mounted() {
    window.userInfor = this.$route.params.code;
    this.rudderInviteCode = this.$route.params.code;
    document.title = "邀你体验格隆汇会员";
    this.getUserInfo();
    window.wechatagain = {
      title: "你的好友送你格隆汇会员",
      content: "立享格隆汇会员专属权益体验",
      image: "https://cdn.gelonghui.com/webActive/wechat-vip.png"
    };
  },
  methods: {
    getCode(challenge, validate, seccode) {
      // //获取短信验证码
      // if (!this.phoneNum) {
      //   this.$toast("请输入手机号码");
      //   return;
      // } else if (this.phoneNum.length !== 11 && this.phoneNum.length !== 8) {
      //   this.$toast("请输入8位香港手机号,或者11位大陆手机号~");
      //   return;
      // }
      // let phone = this.phoneNum;
      // let countryCode = phone.length === 11 ? "86" : "852";
      // this.phoneCode = countryCode;
      axios({
        method: "post",
        url: "/api/over-sea-sms/message-code",
        headers: {
          "platform": 'web'
        },
        data: {
          phone: this.phoneNum,
          countryCode: this.phoneCode,
          challenge,
          validate,
          seccode
        }
      }).then(res => {
        if (res.data.statusCode === 200) {
          this.isSendCode = 1;
          this.recuTime();
        } else {
          this.$toast(res.data.message);
        }
      });
    },
    recuTime() {
      //短信验证码倒计时
      this.reTime = 60;
      clearInterval(this.setInTime);
      this.setInTime = setInterval(() => {
        this.reTime--;
        if (this.reTime < 0) {
          this.isSendCode = 2;
        }
      }, 1000);
    },
    sureBind() {
      //确认绑定成功
      let countryCode = this.phoneNum.length === 11 ? "86" : "852",
        phone = this.phoneNum,
        phoneCode = this.code,
        rudderInviteCode = this.rudderInviteCode;
      axios({
        method: "post",
        url: "/api/vips/accept/invite/v1",
        data: {
          countryCode,
          phone,
          phoneCode,
          rudderInviteCode
        }
      })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.isSendCode = 4;
            this.$router.push({
              path: "/success"
            });
          } else if (res.data.statusCode === 417) {
            this.$toast(res.data.message);
          } else if (res.data.statusCode === 406) {
            this.$toast(res.data.message);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getUserInfo() {
      axios({
        methods: "get",
        url: "/api/vips/invite-code/user-info/v1",
        params: {
          inviteCode: this.rudderInviteCode
        }
      })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.userInfor = res.data.result;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    //向后台请求 初始化数据
    init() {
      //获取短信验证码
      if (!this.phoneNum) {
        this.$toast("请输入手机号码");
        return;
      } else if (this.phoneNum.length !== 11 && this.phoneNum.length !== 8) {
        this.$toast("请输入8位香港手机号,或者11位大陆手机号~");
        return;
      }
      let phone = this.phoneNum;
      let countryCode = phone.length === 11 ? "86" : "852";
      this.phoneCode = countryCode;
      axios({
        url: '/api/over-sea-sms/gt-init',
        method: 'post',
        headers: {
          "platform": 'web'
        },
        data: {
          phone,
          countryCode
        }
      }).then((res) => {
        if (res.data.statusCode === 200) {
          this.checkCode = res.data.result
          this.initGeetestBehover()
        }

      })
    },
    initGeetestBehover() {
      let _this = this
      initGeetest({
        // 以下配置参数来自服务端
        gt: _this.checkCode.gt,
        challenge: _this.checkCode.challenge,
        offline: !_this.checkCode.success,
        new_captcha: true,
        width: "100%",
        product: "bind",
        lang: 'zh-cn'
      }, function (captchaObj) {
        // 这里可以调用验证实例 captchaObj 的实例方法
        captchaObj.onReady(() => {
          console.log("start captcha content");
          captchaObj.verify();
          captchaObj.onSuccess(() => {
            const result = captchaObj.getValidate();
            console.log("获取到的用户行为参数", result);
            const challenge = result.geetest_challenge;
            const validate = result.geetest_validate;
            const seccode = result.geetest_seccode;

            // 带上之前的验证的参数激活getPhoneCode 重新获取验证码
            _this.getCode(challenge, validate, seccode);
          })

          captchaObj.onError(() => {
            // console.log('失败')
            captchaObj.reset(); // 调用该接口进行重置
          })
          captchaObj.onClose(() => {
            // console.log('关闭')
          })
        })
        // captchaObj.appendTo('#captcha-box');
        // _this.captchaObj = captchaObj


      })
    },
    //二次校验
    doubleVerify() {
      axios({
        methods: 'get',
        url: ''
      }).then(() => {
        // if(成功){
        // 	console.log('该干嘛干嘛')
        // }else{
        // 	this.init()
        // }
      })
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.container {
  position: relative;
  padding-bottom: 26px;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  background: #282c37 url(https://cdn.gelonghui.com/webActive/img_bg.png)
    no-repeat;
  background-size: 100%;

  .share-title,
  .share-equity,
  .share-invalid {
    width: 100%;
  }

  .immediate-get {
    width: 80%;
  }

  .user-infor {
    position: absolute;
    top: 140px;
    left: 0;
    text-align: center;
    width: 100%;

    > img {
      width: 88px;
      border-radius: 50%;
    }

    .user-name {
      margin: 6px 0 18px 0;
      font-size: 34px;
      color: rgba(115, 81, 36, 1);
      line-height: 60px;
    }

    .user-tips {
      font-size: 26px;
      color: rgba(168, 127, 72, 1);
    }

    > input {
      outline: none;
      margin: 40px 0 20px 0;
      padding: 30px 0 30px 21px;
      width: 60%;
      height: 90px;
      font-size: 28px;
      color: #333333;
      border: none;
      background: rgba(239, 226, 200, 1);
      border-radius: 10px;
    }

    .get-code-box {
      width: 60%;
      margin: 0 auto;
      background: rgba(239, 226, 200, 1);
      border-radius: 10px;
      display: flex;
      align-items: center;

      > input {
        margin-top: 6px;
        width: 260px;
        outline: none;
        padding: 30px 0 30px 21px;
        height: 90px;
        font-size: 32px;
        color: #333333;
        border: none;
        background: rgba(239, 226, 200, 1);
      }

      > button {
        margin-left: 30px;
        outline: none;
        border: none;
        background: rgba(239, 226, 200, 1);
        font-size: 24px;
      }

      .get-code {
        color: rgba(115, 81, 36, 1);
      }
    }
  }

  > p {
    margin-top: 40px;
    font-size: 20px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/share.vue